import LoadingScreen from '@/components/LoadingScreen';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhatIs from './components/WhatIs';
import ModuleGallery from './components/ModuleGallery';
import Benefits from './components/Benefits';
import Stats from './components/Stats';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

export default function HomePage() {
  return (
    <>
      <LoadingScreen />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <WhatIs />
          <ModuleGallery />
          <Benefits />
          <Stats />
          <FAQ />
          <ContactForm />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </>
  );
}